import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AdminAuthCtx = createContext(null);
const KEY = "rhm_admin_token";

export const AdminAuthProvider = ({ children }) => {
    const [token, setToken] = useState(() => localStorage.getItem(KEY) || "");
    const [verifying, setVerifying] = useState(false);

    useEffect(() => {
        if (token) {
            setVerifying(true);
            api.get("/admin/verify", { headers: { "X-Admin-Token": token } })
                .catch(() => { localStorage.removeItem(KEY); setToken(""); })
                .finally(() => setVerifying(false));
        }
    }, []); // eslint-disable-line

    const login = async (password) => {
        const { data } = await api.post("/admin/login", { password });
        localStorage.setItem(KEY, data.token);
        setToken(data.token);
        return true;
    };

    const logout = () => {
        localStorage.removeItem(KEY);
        setToken("");
    };

    const authHeaders = () => ({ "X-Admin-Token": token });

    return (
        <AdminAuthCtx.Provider value={{ token, login, logout, authHeaders, verifying, isAuthed: !!token }}>
            {children}
        </AdminAuthCtx.Provider>
    );
};

export const useAdminAuth = () => {
    const ctx = useContext(AdminAuthCtx);
    if (!ctx) throw new Error("useAdminAuth must be inside AdminAuthProvider");
    return ctx;
};
